import React from 'react';
import SubmitClaimWizard from './SubmitClaimWizard';

const JoinDetails = () => {
  return <SubmitClaimWizard initialStep={2} />;
};

export default JoinDetails;